/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Select_Event_Groups_LabelInputs */



/**
* | output |
* | --- |
* | "Select event groups to share" |
*
* @param {Team_Share_Select_Event_Groups_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_select_event_groups_label = /** @type {((inputs?: Team_Share_Select_Event_Groups_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Select_Event_Groups_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner les groupes d’événements à partager")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Ereignisgruppen aus, die Sie teilen möchten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona i gruppi di eventi da condividere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите группы мероприятий для обмена информацией.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione grupos de eventos para compartir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要分享的活动组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("共有するイベントグループを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("साझा करने के लिए इवेंट समूह चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione os grupos de eventos para compartilhar")
	return /** @type {LocalizedString} */ ("Select event groups to share")
});